import {useCallback, useContext} from 'react';

import {RESPONSE_STATUSES} from '@/src/app/constants/api';
import useUserActions from '@/src/app/store/user/useUserActions';

import PopupContext from '../../../popup/utils/PopupContext';
import ConfirmRemovingSignaturePopupLayout from '../components/ConfirmRemovingSignaturePopupLayout';
import requestDeleteSignature from '../utils/requestDeleteSignature';

const ConfirmRemovingSignaturePopup = () => {
  const {deleteSignature} = useUserActions();
  const {closePopup} = useContext(PopupContext);

  const handleRemoveSignatureClick = useCallback(async () => {
    const {status} = await requestDeleteSignature();

    if (status === RESPONSE_STATUSES.SUCCESS) {
      deleteSignature();
      closePopup();
    }
  }, []);

  return (
    <ConfirmRemovingSignaturePopupLayout
      onCancelClick={closePopup}
      onConfirmClick={handleRemoveSignatureClick}
    />
  );
};

export default ConfirmRemovingSignaturePopup;
